var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warranty-copy",
    fill: "#E2E8F6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8717728,32 L14,25.2827379 L17.337457,22.0202469 L20.9691265,25.5685455 L30.7598967,16 L34,19.1668735 L20.8717728,32 Z M44.5626667,29.5109333 C45.0624,27.6416 48,26.0272 48,24 C48,21.9728 45.0624,20.3584 44.5632,18.4890667 C44.0464,16.5546667 45.7674667,13.6912 44.7877333,11.9973333 C43.7936,10.2794667 40.4437333,10.3450667 39.0496,8.9504 C37.6554667,7.55626667 37.7210667,4.2064 36.0026667,3.21226667 C34.3088,2.23253333 31.4453333,3.9536 29.5109333,3.4368 C27.6416,2.9376 26.0272,0 24,0 C21.9728,0 20.3584,2.9376 18.4890667,3.4368 C16.5546667,3.9536 13.6912,2.23253333 11.9973333,3.21226667 C10.2794667,4.2064 10.3450667,7.55626667 8.9504,8.9504 C7.55626667,10.3445333 4.2064,10.2789333 3.21226667,11.9973333 C2.23253333,13.6912 3.9536,16.5546667 3.4368,18.4890667 C2.9376,20.3584 0,21.9728 0,24 C0,26.0272 2.9376,27.6416 3.4368,29.5109333 C3.9536,31.4453333 2.23253333,34.3088 3.21226667,36.0026667 C4.2064,37.7205333 7.55626667,37.6549333 8.9504,39.0496 C10.3445333,40.4437333 10.2789333,43.7936 11.9973333,44.7877333 C13.6912,45.7674667 16.5546667,44.0464 18.4890667,44.5632 C20.3584,45.0624 21.9728,48 24,48 C26.0272,48 27.6416,45.0624 29.5109333,44.5632 C31.4453333,44.0464 34.3088,45.7674667 36.0026667,44.7877333 C37.7205333,43.7936 37.6549333,40.4437333 39.0496,39.0496 C40.4437333,37.6554667 43.7936,37.7210667 44.7877333,36.0026667 C45.7674667,34.3088 44.0458667,31.4453333 44.5626667,29.5109333 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.c7c2a5dc86a00fdf70c6ceb16acc8707.svg";
export { ForwardRef as ReactComponent };